import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './ProductInfo.style'
import EndIconButton from '../EndIconButton'

const ProductInfoVariationForty = (props) => {
  const styles = useStyles()
  const { t } = props

  return (
    <Box
      sx={{
        ...(props.showHalfWidth && {
          width: {
            xs: '100% !important',
            md: '49% !important',
          },
        }),
      }}
      style={{
        backgroundImage: `url(${props.imageUrl})`,
      }}
      className={[
        styles.fortyVariantRoot,
        props.left ? styles.fortyVariantRootLeft : '',
      ].join(' ')}
    >
      <Box className={props.imageUrl ? styles.fortyVariantSubTypeImage : ''}>
        {props.icon && (
          <Box className={styles.fortyVariantIcon}>{props.icon}</Box>
        )}
        {props.subtitle && (
          <Typography variant="body2">{t(props.subtitle)}</Typography>
        )}
        {props.title && (
          <Typography
            variant="h1"
            className={
              props.imageUrl
                ? styles.fortyVariantTitleForImage
                : styles.fortyVariantTitle
            }
          >
            {t(props.title)}
          </Typography>
        )}
      </Box>
      {props.ctaTitle && (
        <EndIconButton
          link={props.ctaHref}
          title={t(props.ctaTitle)}
          className={styles.fortyVariantButton}
        />
      )}
    </Box>
  )
}

export default ProductInfoVariationForty
